import React from "react";
import PropTypes from "prop-types";
import Script from "react-load-script";

import LoadingIndicator from "components/LoadingIndicator";

class ScriptLoader extends React.Component {
    constructor(props) {
        super(props);

        this.onLoad = this.onLoad.bind(this);

        this.state = {
            isLoaded: false
        };
    }

    onLoad() {
        this.setState({
            isLoaded: true
        });
    }

    render() {
        const { url, renderLoadingIndicator } = this.props;

        return (
            <React.Fragment>
                <Script url={url} onLoad={this.onLoad} />

                {this.state.isLoaded ? this.props.children : renderLoadingIndicator()}
            </React.Fragment>
        );
    }
}

ScriptLoader.defaultProps = {
    renderLoadingIndicator: () => <LoadingIndicator /> // eslint-disable-line react/display-name
};

ScriptLoader.propTypes = {
    url: PropTypes.string.isRequired,
    renderLoadingIndicator: PropTypes.func,
    children: PropTypes.node
};

export default ScriptLoader;
